import { ApprovedMedia, ApprovedSeries, CoherentScreen, CuratedMediaList, CuratedSeriesList, ProcessedMediaStates, WatchingProfileMetric } from "models";
import rq from 'components/RedQuick'
import React from "react";
import { useTheme } from "@emotion/react";
import { Views } from "enumerations";
import { ResolvePath, GetCachedUrls, ResolveStorageUrl } from "features/firebase-app";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import profile from "react-syntax-highlighter/dist/esm/languages/hljs/profile";
import TitleService from "title-service";
import { useLocalId, useBrowserInfo, mobileAndTabletCheck, useStutter } from "./utility";
import { get_selected_device } from "features/device/device-slice";
import PreviewModalInfo from "./PreviewModalInfo";
import DetailModalContainer from "./DetailModalContainer";
import PTrackContainer from "./PTrackContainer";
import { Button } from "@mui/material";
import { getSrc } from "features/shared_components";
import theme from "themes";
import EpisodeItem from "./EpisodeItem";
import EpisodeSelector from "./EpisodeSelector";
import EpisodeSelectorContainer from "./EpisodeSelectorContainer";
import EpisodeSelectorHeader from "./EpisodeSelectorHeader";
import PTrackContent from "./PTrackContent";
import PreviewModalDetail from "./PreviewModalDetail";
import { getLocationPath } from "./PreviewCoherentScreenModelComponent";
import * as SC from 'features/shared_components'


export interface PreviewSeriesPopupComponentProps {
    approvedSeries_list: ApprovedSeries[],
    approvedMedia_list: ApprovedMedia[],
    componentRef_size: any
}
export default function PreviewSeriesPopupComponent({
    approvedSeries_list,
    approvedMedia_list,
    componentRef_size
}: PreviewSeriesPopupComponentProps) {
    const theme = useTheme()
    const params = useParams()
    let dispatch = useDispatch()
    const navigate = useNavigate()
    const localDeviceId = useLocalId()
    const browserInfo = useBrowserInfo()
    const [urlUpdated, setUrlUpdated] = React.useState(null)
    let device = useSelector(get_selected_device)
    const [currentSeasonId, setCurrentSeasonId] = React.useState(null)
    const [selectedSeasonIndex, setSelectedSeasonIndex] = React.useState(null)
    function getSrc(location: string, url: string, size: number) {
        let states: ProcessedMediaStates[] = []
        approvedSeries_list.find((approved_series) => {
            if (approved_series?.processedSeries?.states) {
                states.push(
                    ...approved_series?.processedSeries?.states?.filter((st) => {
                        let found = st.sourceLocation === location
                        return found
                    }),
                )
            }
        })
        if (!states.length) {
            approvedMedia_list.find((approved_media) => {
                if (approved_media?.processedMedia?.states) {
                    states.push(
                        ...approved_media?.processedMedia?.states?.filter((st) => {
                            let found = st.sourceLocation === location
                            return found
                        }),
                    )
                }
            })
        }
        if (states.length) {
            states = states.sort((a, b) => {
                return Math.abs(a.width - size) - Math.abs(b.width - size)
            })
            let temp = states.filter((a) => a.width - size > 0)
            let state = temp[0] || states[0]
            let cached_url = GetCachedUrls(state.location)
            if (!cached_url) {
                ResolveStorageUrl(state.location).then((res) => {
                    if (res) {
                        setUrlUpdated((urlUpdated || 0) + 1)
                    }
                })
            } else {
                return cached_url
            }
            if (mobileAndTabletCheck()) {
                return null
            }
        }
        return url
    }
    return (

        <rq.RedQuickScrollDialog
            open={params.component || false}
            sx={{
                [`--dialog-background`]:
                    theme?.palette?.dark[900] || '#ffffff',
            }}
            close={() => {
                navigate(ResolvePath(`/${getLocationPath()}/${params.id}`))
            }}
        >
            {(() => {
                let tempApprovedSeries: any = null
                let season: any = null

                let episodes: any = []
                if (params?.component) {
                    tempApprovedSeries = approvedSeries_list.find(
                        (v) => v.seriesId === params?.component,
                    )
                    if (!tempApprovedSeries) {
                        tempApprovedSeries = approvedMedia_list.find(
                            (v) => v.mediaId === params?.component,
                        )
                    } else {
                        if (currentSeasonId) {
                            season = tempApprovedSeries.seasons.find((v) => {
                                return v.id === currentSeasonId
                            })
                        } else if (
                            tempApprovedSeries?.seasons &&
                            tempApprovedSeries?.seasons[0]
                        ) {
                            season = tempApprovedSeries?.seasons[0]
                        }
                    }
                }
                let approvedMedia = approvedMedia_list.find(
                    (v) => v.mediaId === tempApprovedSeries?.media?.id,
                )
                if (season) {
                    episodes = season?.approvedMedia
                        ?.map((m) => {
                            return approvedMedia_list.find((v) => v.id === m)
                        })
                        .filter((x) => x)
                        .map((v) => v.media);
                    approvedMedia = season?.approvedMedia
                        ?.map((m) => {
                            return approvedMedia_list.find((v) => v.id === m)
                        })[0];
                }
                let backgroundImage = getSrc(
                    tempApprovedSeries?.series?.titleMediaImageLocation ||
                    tempApprovedSeries?.media?.thumbnailLocation ||
                    '',
                    tempApprovedSeries?.series?.titleMediaImageUrl ||
                    tempApprovedSeries?.media?.thumbnail ||
                    '',
                    componentRef_size?.width || 1920,
                )
                let titleImage = getSrc(
                    tempApprovedSeries?.series?.titleTransparentLocation ||
                    tempApprovedSeries?.media?.transparentTitleLocation ||
                    '',
                    tempApprovedSeries?.series?.titleTransparentUrl ||
                    tempApprovedSeries?.media?.transparentTitleUrl ||
                    '',
                    (componentRef_size?.width || 0) / 2 || 1920,
                )
                return (
                    <>
                        <rq.RedQuickBillboard
                            billboardStyle={{
                                [`--background-color`]:
                                    theme?.palette?.dark[900] || '#ffffff',
                                [`--dialog-background`]:
                                    theme?.palette?.dark[900] || '#ffffff',
                            }}
                            playUrl={
                                tempApprovedSeries?.series?.id
                                    ? `/${Views.Watch}/${tempApprovedSeries?.id}/${approvedMedia?.mediaId}/${approvedMedia?.id}`
                                    : `/${Views.Watch}/inde/${tempApprovedSeries?.media?.id}/${approvedMedia?.id}`
                            }
                            hideInfoButton
                            backgroundImage={backgroundImage}
                            videoUrl={
                                tempApprovedSeries?.series?.titleMediaUrl ||
                                tempApprovedSeries?.media?.mediaRel ||
                                ''
                            }
                            playTitle={TitleService(
                                tempApprovedSeries?.series?.name ||
                                tempApprovedSeries?.media?.name ||
                                '',
                            )}
                            titleImage={titleImage}
                            description={
                                tempApprovedSeries?.series?.description ||
                                tempApprovedSeries?.media?.description
                                    ?.descriptionDefault ||
                                ''
                            }
                        />
                        <div
                            style={{
                                position: 'absolute',
                                top: 20,
                                right: 20,
                                zIndex: 10,
                            }}
                        >
                            <Button
                                variant="text"
                                onClick={() => {
                                    navigate(
                                        ResolvePath(`/${getLocationPath()}/${params.id}`),
                                    )
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="icon icon-tabler icon-tabler-square-x"
                                    width="56"
                                    height="56"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="#000000"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <rect x="4" y="4" width="16" height="16" rx="2" />
                                    <path d="M10 10l4 4m0 -4l-4 4" />
                                </svg>
                            </Button>
                        </div>
                        {tempApprovedSeries?.seasons && (
                            <div
                                style={{
                                    backgroundColor: theme?.palette?.dark[900],
                                }}
                                className="playwatch-ptrack-content playwatch-detail-modal-container playwatch-ptrack-container playwatch-preview-modal-info playwatch-preview-modal-detail playwatch-episode-selector-header playwatch-detail-modal-container playwatch-episode-item playwatch-episode-selector playwatch-episode-selector-container "
                            >
                                <PreviewModalInfo>
                                    <DetailModalContainer>
                                        <PTrackContainer>
                                            <div>
                                                {tempApprovedSeries?.seasons && (
                                                    <PreviewModalDetail
                                                        year={SC.decipherDate(
                                                            tempApprovedSeries?.series?.releaseDate,
                                                        )?.getFullYear()}
                                                        duration={`${tempApprovedSeries?.seasons
                                                            ?.length} ${tempApprovedSeries?.seasons?.length > 1
                                                                ? TitleService('Seasons')
                                                                : TitleService('Season')
                                                            }`}
                                                        description={TitleService(
                                                            tempApprovedSeries?.series?.description,
                                                        )}
                                                        distributor=""
                                                        genreTags={[]}
                                                        tags={[]}
                                                    ></PreviewModalDetail>
                                                )}
                                                {!tempApprovedSeries?.seasons && (
                                                    <PreviewModalDetail
                                                        year={SC.decipherDate(
                                                            tempApprovedSeries?.media?.releaseDate,
                                                        )?.getFullYear()}
                                                        duration={``}
                                                        description={TitleService(
                                                            tempApprovedSeries?.media?.description
                                                                ?.defaultDescription,
                                                        )}
                                                        distributor=""
                                                        genreTags={[]}
                                                        tags={[]}
                                                    ></PreviewModalDetail>
                                                )}
                                            </div>
                                            <PTrackContent>
                                                <EpisodeSelector>
                                                    <EpisodeSelectorHeader
                                                        selectedSeasonIndex={selectedSeasonIndex}
                                                        season={
                                                            tempApprovedSeries?.seasons?.length || 0
                                                        }
                                                        onSetSeasonIndex={(index) => {
                                                            setSelectedSeasonIndex(index)
                                                            if (
                                                                tempApprovedSeries?.seasons &&
                                                                tempApprovedSeries?.seasons[index]
                                                            ) {
                                                                setCurrentSeasonId(
                                                                    tempApprovedSeries?.seasons[index]
                                                                        ?.id,
                                                                )
                                                            }
                                                        }}
                                                        seasons={tempApprovedSeries?.seasons}
                                                    ></EpisodeSelectorHeader>
                                                    <EpisodeSelectorContainer>
                                                        {episodes.map((episode, index) => (
                                                            <EpisodeItem
                                                                onPlay={() => {
                                                                    let ap = approvedMedia_list.find(
                                                                        (x) => x.mediaId === episode.id,
                                                                    )
                                                                    if (ap?.id) {
                                                                        navigate(
                                                                            `/${Views.Watch}/${tempApprovedSeries?.id}/${ap?.mediaId}/${ap?.id}`,
                                                                        )
                                                                    }
                                                                }}
                                                                title={episode.name}
                                                                number={index + 1}
                                                                time={episode.mediaDuration}
                                                                thumbnailUrl={episode?.thumbnail}
                                                                description={
                                                                    episode?.description
                                                                        ?.descriptionDefault
                                                                }
                                                                key={`episode-${index}`}
                                                            />
                                                        ))}
                                                    </EpisodeSelectorContainer>
                                                </EpisodeSelector>
                                            </PTrackContent>
                                        </PTrackContainer>
                                    </DetailModalContainer>
                                </PreviewModalInfo>
                            </div>
                        )}
                    </>
                )
            })()}
        </rq.RedQuickScrollDialog>
    )
}